import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import useAppMethods from '../../hooks/utility/useAppMethods';
import { Modifier as ModifierData } from '../../services/exports/Interfaces';
import { Checkbox, Radio } from '@mui/material';

interface Props {
  data: ModifierData;
  isSelected: boolean;
  isSingleSelect: boolean;
  toggle: (modifier: ModifierData) => void;
}

export default function Modifier(props: Props) {
  const { t } = useTranslation(null, { keyPrefix: 'Components:Menu:Modifier' });

  const { data, isSelected, isSingleSelect, toggle } = props;

  const { formatCurrency } = useAppMethods();

  function toggleModifier(): void {
    if (!data.is_available) {
      return;
    }

    toggle(data);
  }

  function getPrice() {
    const isDiscount: boolean = data.actual_price !== data.original_price;

    return data.is_available ? (
      <div className="flex flex-row items-center my-auto">
        <p className={priceStyle(isDiscount, data.is_available)}>+ {formatCurrency(data.original_price)}</p>
        {isDiscount && <p className={highlightedPriceStyle}>+ {formatCurrency(data.actual_price)}</p>}
      </div>
    ) : null;
  }

  return (
    <button
      className={classnames(container, {
        'touchable-highlight': data.is_available,
      })}
      onClick={toggleModifier}
    >
      <div className="mr-xs my-auto">
        {isSingleSelect ? <Radio checked={isSelected} /> : <Checkbox checked={isSelected} />}
      </div>
      <div className="flex-1 my-auto">
        <p
          className={classnames('mr-xs text-left', {
            'opacity-25': !data.is_available,
          })}
        >
          {data.name}
        </p>
      </div>
      {getPrice()}
      {!data.is_available && <p className="ml-xs text-brand-primary my-auto">{t('labels.sold_out')}</p>}
    </button>
  );
}

const container =
  "flex flex-row w-full mb-md before:relative after:content-[''] after:absolute after:-top-0 after:-bottom-0";

const priceStyle = (isDiscount?: boolean, isAvailable?: boolean) =>
  classnames('text-gray-700 line-clamp-1 text-right text-sm', {
    'line-through': isDiscount,
    'opacity-25': !isAvailable,
  });

const highlightedPriceStyle = 'text-black text-right text-sm font-medium line-clamp-1 ml-xs';
